import { useCallback } from 'react';
import { replace, push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';
import { assembleRoutePath } from 'functions/assembleRoutePath';
import { store } from 'utils/exportStore';

export const useUpdateLocationSearchParameters = ({ isPushMethod = true } = {}) => {
  const dispatch = useDispatch();

  return useCallback((searchParametersToUpdate) => {
    // use store to overcome stale search parameters that comes from useLocation
    const { router: { location: { pathname, search, hash } } } = store.getState();

    const action = isPushMethod ? push : replace;

    // location.query is not used due to it cannot have several search parameters with the same name (e.g. foo=1&foo=2&foo=3)
    // probably it is possible to use window.location.search
    const { query } = queryString.parseUrl(search);

    dispatch(action(assembleRoutePath({
      pathname,
      hash,
      searchParameters: {
        ...query,
        ...searchParametersToUpdate,
      },
    })));
  }, [dispatch, isPushMethod]);
};
